import { Language } from '@shared-enums';

export const allowedLanguages = [
  Language.HR,
  Language.EN,
  // Language.FR,
  // Language.DE,
  // Language.IT,
];
